import React from "react";
import ChevronUpIcon from "@atlaskit/icon/glyph/chevron-up";
import ChevronDownIcon from "@atlaskit/icon/glyph/chevron-down";
import propEq from "ramda/src/propEq";
import insert from "ramda/src/insert";

import { SubNav } from "./SubNav";
import { ListItemText } from "../../UI/ListItemText";

import { StyledListItemButton } from "./styles";
import { SUBNAV } from "./types";
import { ListItemIcon } from "../../UI/ListItemIcon";
import { URL } from "../../constants/navigation";
import { useNetwork } from "../../hooks/useNetwork";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { getUserLinks } from "../../routes/users/UserContainer";
import useAuth from "../../routes/login/AuthContext";
import { useSelectedNetworkImportTypes } from "../../hooks/useSelectedNetworkImportType";

interface IProps {
  subnavOpen?: SUBNAV;
  toogleSubnav: VoidFunction;
}

const getExpandLink = (open: boolean) =>
  open ? <ChevronUpIcon label="Chevron up" /> : <ChevronDownIcon label="Chevron down" />;

export const UsersItem: React.FC<IProps> = (props) => {
  const { isWriteAccess } = useAuth();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { getL2s } = useNetwork();
  const { isEntrata } = useSelectedNetworkImportTypes();

  const l2s = getL2s(selectedNetworkId);

  const isPlacementWorsheet = l2s.some(propEq("placementWorksheetEnabled", true));

  // Get user links first
  let userSubnavLinks = getUserLinks();

  // If placement worksheet is enabled, insert "Place" before "Send to Entrata" (if it exists)
  if (isPlacementWorsheet && isWriteAccess()) {
    const hasSendToEntrata = isEntrata && isWriteAccess();

    if (hasSendToEntrata) {
      // Find the index of "Send to Entrata" and insert "Place" before it
      const sendToEntrataIndex = userSubnavLinks.findIndex(link => link.name === "Send to Entrata");
      if (sendToEntrataIndex !== -1) {
        userSubnavLinks = insert(sendToEntrataIndex, { name: "Place", url: URL.PLACEMENT_WORKSHEET }, userSubnavLinks);
      } else {
        // Fallback: insert at the end if "Send to Entrata" not found
        userSubnavLinks = insert(-1, { name: "Place", url: URL.PLACEMENT_WORKSHEET }, userSubnavLinks);
      }
    } else {
      // No "Send to Entrata", insert at the end
      userSubnavLinks = insert(-1, { name: "Place", url: URL.PLACEMENT_WORKSHEET }, userSubnavLinks);
    }
  }

  const links = userSubnavLinks;

  return (
    <>
      <StyledListItemButton onClick={props.toogleSubnav}>
        <ListItemIcon>
          <img src="/static/images/icons/users.svg" alt="Users" />
        </ListItemIcon>
        <ListItemText primary="Users" />
        {getExpandLink(props.subnavOpen === SUBNAV.USERS)}
      </StyledListItemButton>
      <SubNav in={props.subnavOpen === SUBNAV.USERS} links={links} />
    </>
  );
};